import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { HeaderService } from '@shared/modules/header/services/header.service';

@Component({
  selector: 'app-excel-import-page-header',
  templateUrl: './excel-import-page-header.component.html',
  styleUrls: ['./excel-import-page-header.component.scss'],
})
export class ExcelImportPageHeaderComponent implements OnInit {
  headerTitle$: Observable<string>;

  constructor(private headerService: HeaderService) {}

  ngOnInit(): void {
    this.headerTitle$ = this.getHeaderTitle();
  }

  private getHeaderTitle(): Observable<string> {
    return this.headerService.select('title');
  }
}
